import { PageRequest } from '@/components/table/types/PageRequest.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import { PagedDto } from '@/components/table/types/PagedDto.ts';
import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { TableDefinitionDto } from '@/components/table/types/TableDefinitionDto.ts';
import { buildPageRequestParams } from '@/components/table/types/TableUtil.ts';
import { ClientListDto } from '@/features/dashboard/clients/types/ClientListDto.ts';

const tourClientsApi = {
  getClients: async (
    tourId: string,
    pageRequest: PageRequest,
    filterCriteria: FilterCriteriaDto,
  ): Promise<PagedDto<ClientListDto>> => {
    const params = buildPageRequestParams(pageRequest);
    return await fetchPrivateApi<PagedDto<ClientListDto>>(
      'POST',
      `tours/${tourId}/clients/all?${params.toString()}`,
      filterCriteria,
    );
  },
  getTableDef: async (tourId: string): Promise<TableDefinitionDto> => {
    return await fetchPrivateApi<TableDefinitionDto>(
      'GET',
      `tours/${tourId}/clients/table-definition`,
    );
  },
};

export default tourClientsApi;
